import { Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';

export const producerGroupRoutes: Routes = [
    {
        path: 'profile',
        loadChildren: () => import('../producer-group/profile/profile.module').then((m) => m.ProfileModule),
        canActivate: [authGuard]
    },
    {
        path: 'activity',
        loadChildren: () => import('../producer-group/activity/activity.module').then((m) => m.ActivityModule),
        canActivate: [authGuard]
    },
    {
        path: 'business-plan',
        loadChildren: () =>
            import('../producer-group/business-plan/business-plan.module').then((m) => m.BusinessPlanModule),
        canActivate: [authGuard]
    },
    {
        path: 'profit-settlement',
        loadChildren: () =>
            import('../producer-group/profit-settlement/profit-settlement.module').then(
                (m) => m.ProfitSettlementModule
            ),
        canActivate: [authGuard]
    },
    {
        path: 'income-expense',
        loadChildren: () =>
            import('../producer-group/income-expense/income-expense.module').then((m) => m.IncomeExpenseModule),
        canActivate: [authGuard]
    },
    {
        path: 'pg-fund',
        loadChildren: () => import('../producer-group/pg-fund/pg-fund.module').then((m) => m.PGFundModule),
        canActivate: [authGuard]
    }
];

export const producerGroupMobileRoutes: Routes = [
    // Producer Group Mobile Screens
    {
        path: 'mobile/marketplace',
        loadComponent: () =>
            import('../mobile/pages/marketplace/marketplace.component').then((m) => m.MarketplaceComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/product-inquiries/:id',
        loadComponent: () =>
            import('../mobile/pages/product-inquiries/product-inquiries.component').then(
                (m) => m.ProductInquiriesComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/enquiry-success',
        loadComponent: () =>
            import('../mobile/pages/enquiry-success/enquiry-success.component').then((m) => m.EnquirySuccessComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/enquiry-error/',
        loadComponent: () =>
            import('../mobile/pages/enquiry-error/enquiry-error.component').then((m) => m.EnquiryErrorComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/explore',
        loadComponent: () => import('../mobile/pages/explore/explore.component').then((m) => m.ExploreComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/pg-list/:id',
        loadComponent: () => import('../mobile/pages/pg-list/pg-list.component').then((m) => m.PGListComponent),
        canActivate: [authGuard]
    }
];
